import { validatePhone } from './Identity';

export const validatePhoneNumber = ({ callingCode, nationalNumberRaw }) => {
  const nationalNumber = nationalNumberRaw
    .trim()
    .split(' ')
    .join('')
    .split('-')
    .join('');

  const e164Number = callingCode + nationalNumber;
  return validatePhone(e164Number).then(result => {
    const { validated } = result;
    if (!validated) {
      return Promise.reject();
    }

    return result;
  });
};
